package pl.nickers.match3

import androidx.compose.runtime.Composable
import pl.nickers.match3.ui.AppScreen

@Composable
fun App() = AppScreen()
